import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { persistStorage } from './persistStorage';

const usePlaces = create(
  persist(
    (set) => ({
      isSearching: false,
      cityIsSelected: false,
      allPlaces: [],
      places: [],
      withoutCommercialPlaces: [],
      popPlaces: [],
      seePlaces: [],
      cities: [],
      setAllPlaces: (places) => set({ allPlaces: places }),
      setPlaces: (places) => set({ places }),
      setPopPlaces: (places) => set({ popPlaces: places }),
      setWithoutCommercialPlaces: (places) =>
        set({ withoutCommercialPlaces: places }),
      setSeePlaces: (places) => set({ seePlaces: places }),
      setCities: (cities) => set({ cities }),
      filterByCity: (city) => {
        set((state) => ({
          places: state.seePlaces.filter(
            (place) => city === place.contact.address?.city,
          ),
        }));
      },
      setIsSearching: (value) => set({ isSearching: value }),
      setCitySelected: (value) => set({ cityIsSelected: value }),
    }),
    {
      name: 'places',
      storage: createJSONStorage(() => persistStorage),
      partialize: (state) => {
        const { cityIsSelected, ...rest } = state;
        return { ...rest };
      },
      version: 2,
      migrate: (persistedState) => persistedState,
    },
  ),
);

export default usePlaces;
